import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  COMPLIMENTARY_NIGHT_BASE_URL,
  TENANT_NAME,
  TENANT_PRIVACY_POLICY_URL,
  TENANT_PRIVACY_STATEMENT_URL,
  TENANT_TNCS_URL,
  TRAVEL_EDGE_BASE_URL,
} from '@rd/core/tokens/rd-lib.token';
import { AuthRenderState } from '@rd/types';
import { Nullable, StartsWithHttps } from 'global-types';
import { getAuthRenderState } from '../../auth/store/selectors/auth.selectors';
import { CoreState } from '../../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class UrlUtilsService {
  authRenderState: AuthRenderState;

  constructor(
    @Inject(TENANT_PRIVACY_POLICY_URL)
    protected tenantPrivacyPolicyUrl: Nullable<StartsWithHttps>,
    @Inject(TENANT_TNCS_URL)
    protected tenantTncsUrl: Nullable<StartsWithHttps>,
    @Inject(TRAVEL_EDGE_BASE_URL)
    private travelEdgeBaseUrl: StartsWithHttps,
    @Inject(COMPLIMENTARY_NIGHT_BASE_URL)
    private complimentaryNightBaseUrl: Nullable<StartsWithHttps>,
    @Inject(TENANT_NAME) private tenantName: string,
    @Inject(TENANT_PRIVACY_STATEMENT_URL)
    protected tenantPrivacyStatementUrl: Nullable<StartsWithHttps>,
    private store: Store<CoreState>,
  ) {
    this.store.select(getAuthRenderState).subscribe((authRenderState) => {
      this.authRenderState = authRenderState;
    });
  }

  imageUrl(path: string): string {
    return `/assets${path}`;
  }

  travelEdgeUrl(path: string = ''): URL {
    if (this.authRenderState === 'loggedIn') {
      return new URL(
        `${this.travelEdgeBaseUrl}/whitelabel/${this.tenantName}/login?redirect=${this.travelEdgeBaseUrl}${path}`,
      );
    } else {
      return new URL(`${this.travelEdgeBaseUrl}${path}`);
    }
  }

  complimentaryNightUrl(path: string): URL {
    if (this.authRenderState === 'loggedIn') {
      return new URL(
        `${this.travelEdgeBaseUrl}/whitelabel/${this.tenantName}/login?redirect=${this.complimentaryNightBaseUrl}${path}`,
      );
    } else {
      return new URL(`${this.complimentaryNightBaseUrl}${path}`);
    }
  }

  privacyPolicyUrl(): URL {
    if (!!this.tenantPrivacyPolicyUrl) {
      return new URL(this.tenantPrivacyPolicyUrl);
    } else {
      return this.travelEdgeUrl('/terms/privacy');
    }
  }

  privacyStatementUrl(): URL {
    if (!!this.tenantPrivacyStatementUrl) {
      return new URL(this.tenantPrivacyStatementUrl);
    } else {
      return this.travelEdgeUrl('/terms/privacy-statement');
    }
  }

  tncsUrl(): URL {
    if (!!this.tenantTncsUrl) {
      return new URL(this.tenantTncsUrl);
    } else {
      return this.travelEdgeUrl('/terms/terms_condition');
    }
  }
}
